var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, ctaButtonName } = options; 
__p+=' ';
 if(!_.isUndefined(property))
{ 
__p+='\n';
 const propertyText = property.name && property.name.toLowerCase().includes("plan") ? `${property.name}` : `${property.name} plan` 
__p+='\n';
 let placeholder = property.status === 'new_plan' ? `I am interested in ${propertyText} in the ${property.new_community_name} community` : 'Request Details' 
__p+='\n\n<div class="qv-office-hours">\n  <div class="panel">\n    <div\n      class="accordion-heading collapsed"\n      role="tab"\n      data-toggle="collapse"\n      href="#collapse-office-hours"\n      aria-expanded="false"\n      aria-controls="collapse-office-hours"\n      data-omtag="ldp:office-hours:expand"\n    >\n      <h2 class="title-section accordion-title">\n        <i class="ra ra-open-house icon-space-right"></i>Office Hours\n      </h2>\n    </div>\n    <p class="sec-summary ellipsis">\n      <a\n        href="javascript:void(0)"\n        data-omtag="ldp:office-hours:contact-agent"\n        data-title="Find out more about this plan"\n        data-target="#ldpStickyBottomLeadModal"\n        class="js-qv-contact-agent round-cta"\n        office-hours\n      >\n        '+
((__t=(ctaButtonName ))==null?'':__t)+
'\n      </a>\n    </p>\n    <div\n      id="collapse-office-hours"\n      class="panel-collapse collapse"\n      role="tabpanel"\n      aria-labelledby="collapseofficeHours"\n    >\n      <div class="panel-body">\n        <div class="font-semibold margin-bottom">\n          '+
((__t=( property.office_hours ))==null?'':__t)+
'\n        </div>\n        <div class="margin-top-lg">\n          <a\n            href="javascript:void(0)"\n            data-target="#ldpStickyBottomLeadModal"\n            class="btn btn-primary js-qv-contact-agent round-cta"\n            data-placeholder="'+
((__t=( placeholder ))==null?'':__t)+
'"\n            data-omtag="ldp:office-hours:contact-agent"\n            data-title="Find out more about this plan"\n            office-hours\n          >\n            '+
((__t=(ctaButtonName ))==null?'':__t)+
'\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-office-hours.jst.ejs